// extracted by mini-css-extract-plugin
module.exports = {"fixed":"Dialog_fixed__2wM4_","draggable":"Dialog_draggable__27apW","rnd":"Dialog_rnd__2qLVA","dialog":"Dialog_dialog__2aVsd","backdrop":"Dialog_backdrop__2BJFR"};